import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const routes = [
  {
    path: '/login',
    component: () => import('./view/login/index.vue'),
  },
  {
    path: '/login/index',
    component: () => import('./view/login/index.vue'),
  },
  {
    path: '/white-list/index',
    component: () => import('./view/white-list/index.vue'),
  },
  {
    path: '/uploadImg/indexgg', //别泄露了
    component: () => import('./view/upload-img/index.vue'),
  },
  {
    path: '/wx-auth-redirect/index',
    component: () => import('./view/wx-auth-redirect/index.vue'),
  },
  {
    path: '/agreement/index',
    component: () => import('./view/agreement/index.vue'),
  },
  {
    path: '/data-screen',
    component: () => import('./view/data-screen/index.vue'),
  },
  {
    // 企微api要求用于签名的回调路径不带#后内容 https://open.work.weixin.qq.com/devtool/query?e=40093
    path: '/',
    component: () => import('./view/crm-auto-login/index.vue'),
  },
  // 地推活动
  {
    path: '/popularize/index',
    component: () => import('./view/popularize/index.vue'),
  },
  {
    path: '/popularize/admin',
    component: () => import('./view/popularize/admin.vue'),
  },
  {
    path: '/popularize/login',
    component: () => import('./view/popularize/login.vue'),
  },
  {
    path: '/popularize/agreement',
    component: () => import('./view/popularize/agreement.vue'),
  },
  {
    path: '/popularize/activityList',
    component: () => import('./view/popularize/activityList.vue'),
  },
  {
    path: '/popularize/team',
    component: () => import('./view/popularize/team.vue'),
  },
  {
    path: '/popularize/user',
    component: () => import('./view/popularize/user.vue'),
  },
  {
    path: '/popularize/profit',
    component: () => import('./view/popularize/profit.vue'),
  },
  {
    path: '/popularize/teamProfit',
    component: () => import('./view/popularize/teamProfit.vue'),
  },
  {
    path: '/popularize/teamData',
    component: () => import('./view/popularize/teamData.vue'),
  },
  {
    path: '/download',
    component: () => import('./view/app-download/index.vue'),
  },
  {
    path: '/xiaoxiang-app',
    component: () => import('./view/xiaoxiang-app/index.vue'),
  },
  {
    path: '/protocol',
    component: () => import('./view/mini-program-protocol/index.vue'),
  },
  {
    path: '/apply-contract',
    component: () => import('./view/mini-program-protocol/apply-contract.vue'),
  },
  {
    path: '/agreement-pdf-viewer',
    component: () => import('./view/agreement-pdf-viewer/index.vue'),
  },
  {
    path: '/mini-program-bind',
    component: () => import('./view/mini-program-bind/index.vue'),
  },
  {
    path: '/material-webview',
    component: () => import('./view/material-webview/index.vue'),
  },
];

const router = new Router({
  // mode: 'history',
  routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/pages/miaocode/router.js